/**
 * Created by swifta on 1/22/18.
 */
import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Constants} from "../util/Constants";

@Injectable()
export class AnonymousService {

  constructor(public http: Http) {
  }

  getRoles() {
    return this.http.get(Constants.GET_ROLES_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getPermissions() {
    return this.http.get(Constants.GET_PERMISSIONS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getRole(id) {
    return this.http.get(Constants.GET_ROLES_URL + id, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deletRole(id: any) {
    return this.http.delete(Constants.DELETE_ROLES_URL + id, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUser(userId: number) {
    return this.http.get(Constants.USERS_URL + userId, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAgentNetworksConfig(userId: number) {
    return this.http.get(Constants.USERS_NETWORK_URL + userId, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUserTransactions(userId: number) {
    return this.http.get(Constants.USERS_TRANSACTIONS_URL + userId + '?pageSize=10' , Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/anonymous-service.ts